export const ProgressIndicator = ({
    currentStep,
    totalSteps,
    percentage,
}: {
    currentStep: number;
    totalSteps: number;
    percentage?: number;
}) => {
    let stepsWidth = percentage ?? (currentStep * 100) / totalSteps;

    let width = percentage ?? stepsWidth;

    return (
        <div className="progress-bar-wrapper relative ec-border-radius-sm full-width">
            <div
                className="progress-bar absolute ec-border-radius-sm full-height"
                style={{ width: `${width ?? 0}%` }}
            ></div>
        </div>
    );
};

ProgressIndicator.defaultProps = {
    totalSteps: process.env.NEXT_PUBLIC_REGISTRATION_FORM_LENGTH
        ? parseInt(process.env.NEXT_PUBLIC_REGISTRATION_FORM_LENGTH)
        : 11,
};
